import { createApiRef } from '@backstage/core-plugin-api';
import type {
  CodeInterviewMessage,
  CodeInterviewResponse,
  CodeIssueContext,
  IssueGetResult,
  IssuesListResult,
} from './types';

export interface SendInterviewMessageRequest {
  repoEntityRef: string;
  issues: CodeIssueContext[];
  messages: CodeInterviewMessage[];
}

export interface CodeBuilderApi {
  /** Runs one stateless interview turn against the code-builder backend. */
  sendInterviewMessage(
    request: SendInterviewMessageRequest,
    signal?: AbortSignal,
  ): Promise<CodeInterviewResponse>;

  /** Lists the open GitHub issues for the repo linked to a catalog entity. */
  listIssues(repoEntityRef: string): Promise<IssuesListResult>;

  /** Fetches a single GitHub issue (body + comments) for that repo. */
  getIssue(repoEntityRef: string, number: number): Promise<IssueGetResult>;
}

export const codeBuilderApiRef = createApiRef<CodeBuilderApi>({
  id: 'plugin.code-builder.service',
});
